import config from '../config';

export const RESET_PASSWORD_RESET = 'RESET_PASSWORD_RESET';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_MATCH_FAILURE = 'RESET_PASSWORD_MATCH_FAILURE';
export const RESET_PASSWORD_NOT_FOUND_FAILURE =
  'RESET_PASSWORD_NOT_FOUND_FAILURE';

function sendResetPasswordRequest() {
  return {
    type: RESET_PASSWORD_REQUEST
  };
}

function receiveResetPasswordSuccess() {
  return {
    type: RESET_PASSWORD_SUCCESS
  };
}

function receiveResetPasswordFailure(e) {
  if (e.status === 400) {
    return {
      type: RESET_PASSWORD_MATCH_FAILURE
    };
  }
  return {
    type: RESET_PASSWORD_NOT_FOUND_FAILURE
  };
}

function handleErrors(res) {
  if (!res.ok) {
    const e = Error(`${res.status} ${res.statusText}`);
    e.status = res.status;
    throw e;
  }
  return res;
}

export function resetResetPassword() {
  return {
    type: RESET_PASSWORD_RESET
  };
}

export function resetPassword(data) {
  return dispatch => {
    dispatch(sendResetPasswordRequest());

    return fetch(`${config.api.baseURL}/reset-password`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(handleErrors)
      .then(res => res.json())
      .then(() => dispatch(receiveResetPasswordSuccess()))
      .catch(e => dispatch(receiveResetPasswordFailure(e)));
  };
}
